import { MISMATCH_TYPE } from "lib/constants";

export function hasMismatch(position) {
    return position.mismatch.length > 0;
}

function getMismatch(position, type) {
    return position.mismatch.filter((m) => m.type === type).pop();
}

export function isMismatch(position) {
    return (
        getMismatch(position, MISMATCH_TYPE.COMMUTE) ||
        getMismatch(position, MISMATCH_TYPE.AVAILABILITY) ||
        getMismatch(position, MISMATCH_TYPE.LOCATION)
    );
}

export function getMismatchText(position) {
    const commuteMismatch = getMismatch(position, MISMATCH_TYPE.COMMUTE);
    return commuteMismatch ? commuteMismatch.text : "";
}
